export const PORTAL_ROLES = {
  employee: 'EdinshallEmployee',
  manageClientAccounts: 'ManageClientAccounts',
  suspendClientAccounts: 'SuspendClientAccounts',
  manageEmployees: 'ManageEdinshallEmployees',
  globalAdmin: 'GlobalAdmin',
  marketingAdmin: 'MARKETING_ADMIN',
  deployToAppCatalog: 'DeployToAppCatalog',
  aiPolicyManager: 'AiPolicyManager',
  aiUsageReviewer: 'AiUsageReviewer',
  qualityReviewer: 'QualityReviewer',
  evidenceManager: 'EvidenceManager',
  documentManager: 'DocumentManager'
} as const;

export type PortalRoleValue = typeof PORTAL_ROLES[keyof typeof PORTAL_ROLES];

const normalize = (value: string): string => value.trim().toLowerCase();

export const hasRole = (roles: string[] | undefined, role: PortalRoleValue): boolean => {
  if (!roles || roles.length === 0) return false;
  const normalized = roles.map(normalize);
  return normalized.includes(normalize(role));
};

export const hasAnyRole = (roles: string[] | undefined, required: PortalRoleValue[]): boolean => {
  if (!roles || roles.length === 0) return false;
  const normalized = roles.map(normalize);
  return required.some((role) => normalized.includes(normalize(role)));
};

/** Returns true if the user holds GlobalAdmin OR the single required role. */
export const hasElevatedAccess = (roles: string[] | undefined, required: PortalRoleValue): boolean =>
  hasRole(roles, PORTAL_ROLES.globalAdmin) || hasRole(roles, required);

/**
 * Returns true if the user holds GlobalAdmin OR any of the required roles.
 * This is the multi-role counterpart of hasElevatedAccess, ensuring both
 * requireRole and requireAnyRole share the same admin-bypass design.
 */
export const hasElevatedAnyRole = (roles: string[] | undefined, required: PortalRoleValue[]): boolean =>
  hasRole(roles, PORTAL_ROLES.globalAdmin) || hasAnyRole(roles, required);
